module.exports = __webpack_public_path__ + "img/vercion3.115e1a02.png";